<template>
  <LayoutContainer
    :id="data.cssId"
    :class="[
      `dbc-c-text-image dbc-c-text-image--medium-${data.mediumPosition} ${
        data.backgroundColor !== null
          ? `dbc-block-background-${data.backgroundColor}`
          : ''
      }`,
      { 'dbc-block-background': !data.image && !data.video },
      data.overlap || data.overlap === null
        ? ''
        : `dbc-c-text-image--no-overlap dbc-c-text-image--no-overlap-${data.mediumPosition}`,
    ]"
  >
    <LayoutBlock
      :aos="{
        fadeDirection: `fade-${mediumAnimationDirection}`,
        delay: 300,
        offset: 200,
      }"
      :class="[
        'dbc-c-text-image__medium-block',
        {
          'dbc-c-text-image__medium-block--background':
            data.mediumPosition === 'background',
        },
      ]"
    >
      <NuxtLink
        v-if="data.image?.link"
        :to="data.image.link"
        :target="resolveLinkTarget(data.image.link)"
      >
        <UtilityImage
          :format="data.image.format"
          :src="data.image.image[0]?.url"
          :alt="data.image.alt"
          loading="lazy"
          :copyright="data.image.copyright"
        />
      </NuxtLink>
      <UtilityImage
        v-else-if="data.image"
        :format="data.image.format"
        :src="data.image.image[0]?.url"
        :alt="data.image.alt"
        loading="lazy"
        :copyright="data.image.copyright"
      />
      <UtilityVideo
        v-if="data.video"
        :id="data.video.id"
        :title="data.video.title"
        :consent-layer="data.video.consentLayer"
      />
    </LayoutBlock>
    <LayoutBlock
      v-if="
        data.category ||
        data.headlineH2 ||
        data.headlineH3 ||
        data.text ||
        data.button
      "
      :aos="{ fadeDirection: `fade-${data.mediumPosition}`, delay: 300 }"
      :class="`dbc-block-background-${data.backgroundColorTextBox} dbc-c-text-image__text-block`"
    >
      <UtilityHeadline
        v-if="data.headlineH2"
        :class="`dbc-text-color-${data.headlineH2Color}`"
        :text="data.headlineH2"
        :level="2"
        :aos="{ fadeDirection: `fade-${data.mediumPosition}`, delay: 400 }"
        :category="{ text: data.category, color: data.categoryColor }"
      />
      <UtilityHeadline
        v-if="data.headlineH3"
        :class="`dbc-text-color-${data.headlineH3Color}`"
        :text="data.headlineH3"
        :level="3"
        :aos="{ fadeDirection: `fade-${data.mediumPosition}`, delay: 450 }"
      />
      <UtilityText
        v-if="data.text"
        :class="`dbc-text-color-${data.textColor}`"
        :text="data.text"
        :aos="{ fadeDirection: `fade-${data.mediumPosition}`, delay: 500 }"
      />
      <UtilityButton
        v-if="data.button"
        :aos="{ fadeDirection: `fade-${data.mediumPosition}`, delay: 550 }"
        :button="data.button"
        :class="''"
      />
    </LayoutBlock>
  </LayoutContainer>
</template>
<script setup lang="ts">
const props = defineProps<{
  content: ContentTextMedia
}>()
const data = normalizeTextMedia(props.content)
const mediumAnimationDirection =
  data.mediumPosition !== 'left' ? 'left' : 'right'
</script>
